export default __webpack_public_path__ + "static/media/Goremonger's Harness.d09839ea.jpg";